<template>
  <b-row >
    <b-col @click="ubuntu = true , debian = false ">
      <b-card >
        <template v-slot:header  >
          <b-row :class="{'os-selected':!debian, 'not-selected': debian}">
            <b-col >
              <h1  >Ubuntu</h1>
            </b-col>
            <b-col class="p-2">
              <img class="float-right mr-3" height="64px"
                   :src='!ubuntu ? "/static/icons/icons8-ubuntu_filled.svg" : "/static/icons/icons8-ubuntu_filled_white.svg"'>
            </b-col>
          </b-row>
        </template>
        <v-select v-if="ubuntu"
                  v-model="osUbuntu"
                  @input="updateShoppingCard(osUbuntu)"
                  :clearable = "false"
                  :options="ubuntuoption">
          <template v-slot:option="option" >
            {{$t('vservers.vserver_template')[option.label]}}
          </template>
        </v-select>
      </b-card>
    </b-col>

    <b-col  @click=" debian = true, ubuntu = false "

            >
      <b-card >
        <template v-slot:header>
          <b-row :class="{'os-selected':!ubuntu, 'not-selected': ubuntu}">
            <b-col>
              <h1 >Debian</h1>
            </b-col>
            <b-col class="p-2">
              <img class="float-right mr-3" height="64px" :src= '!debian ?  "/static/icons/icons8-debian.svg" : "/static/icons/icons8-debian_white.svg"'>
            </b-col>
          </b-row>
        </template>
        <v-select v-if="debian"
                  v-model="osDebian"
                  @input="updateShoppingCard(osDebian)"
                  :clearable = "false"
                  :options="debianoption">
          <template v-slot:option="option" >
            {{$t('vservers.vserver_template')[option.label]}}
          </template>
        </v-select>
      </b-card>
    </b-col>

  </b-row>
</template>

<script>
  import {VserverOrder} from "@/store/models/vserver/vserver_order";
  import {VserverOrderList} from "@/store/models/vserver/vserver_order_list";
  import {PageControl} from "@/store/models/layout/page_control";

  export default {
        name: "luma-os-selection-vserver",
        data:()=>({
            debian:false,
            ubuntu:true,
            osDebian: 'DEBIAN_10',
            osUbuntu: 'UBUNTU_19.10'
        }),
        computed:{
            ubuntuoption(){
               const x = [
                 "UBUNTU_19.10",
                 "UBUNTU_19.04",
                 "UBUNTU_18.10",
                 "UBUNTU_18.04",
                 "UBUNTU_17.10",
                 "UBUNTU_16.04"
               ]
                return x
                // const x = Object.keys( this.$t('vservers.vserver_template') )
                // const y = []
                // const z = x.map(el=>{
                //     const xx = el.split('_')
                //     if(xx[0] === 'UBUNTU') y.push(el)
                // })
                // return y
            },
            debianoption(){
                const x = [
                  "DEBIAN_10",
                  "DEBIAN_9",
                  "DEBIAN_8"
                ]
                return x
                // const x = Object.keys( this.$t('vservers.vserver_template') )
                // const y = []
                // const z = x.map(el=>{
                //     const xx = el.split('_')
                //     if(xx[0] === 'DEBIAN') y.push(el)
                // })
                // return y
            },
            vid(){
                return this.$route.params.id
            }
        },
        methods:{
            updateShoppingCard(os){
                //PAGECONTROLLER
                console.log('UPDATE PAGECONTROLL')
                const x = Object.assign({},new PageControl)
                x.osoption = os
                x.path = this.vid
                console.log('UPDATE PAGECONTROLL::::',os)
                PageControl.find(this.vid)  ? PageControl.update({where:this.vid,data:{osoption:os}})
                                            : PageControl.insertOrUpdate({data: x })
                //ORDER
                if(!VserverOrder.all().length ) return
                const order = VserverOrder.all().map(el=>{
                    VserverOrder.update({where:el.product_key,data:{vserver_template:os}})
                })
                const list = VserverOrderList.all().map(el=>{
                    VserverOrderList.update({where:el.product_key,data:{vserver_template:os}})
              })

            }
        }
    }
</script>

<style scoped>
.selected{
  font-size: xx-large;
}
.os-selected{
  /*padding: 24px;*/
  background-color:#1ab394;
  color: white;
  padding: 0px;
  margin: 0px;
}
  .not-selected{
    padding:0px;
  }
  .card-header{
    padding: 0px;
    background:none ;
  }
</style>



// WEBPACK FOOTER //
// src/components/datacenter/vserver_datacenter/luma-os-selection-vserver.vue